module.exports = __webpack_public_path__ + "static/media/12.cc6316c0.svg";